import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["data", "getRowAttributes", "aria-labelledby", "shouldAutoCollapseOnExpand", "renderCardForRow", "spacing", "isStriped"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useState } from 'react';
import { styledWithTheme } from "../../context";
import { pickDataProps, withTestAttributes } from "../../utils";
import { BACKGROUND_SHADE_COLOR, BORDER_COLOR, BORDER_WIDTH_OUTER } from "../html/constants";
import { defaultProps } from "../constants";
import { mapIndexesToBooleans, setAllValuesToFalse } from "../expandable";
import CardItem from "./CardItem";
import { jsx as ___EmotionJSX } from "@emotion/core";
var CardList = styledWithTheme('ul')(function (_ref) {
  var theme = _ref.theme,
      isStriped = _ref.isStriped;
  var stripedProps = isStriped ? {
    '& > div:nth-of-type(even)': {
      backgroundColor: theme.selectors.color(BACKGROUND_SHADE_COLOR)
    }
  } : {};
  return _objectSpread({
    backgroundColor: theme.selectors.color('neutral0'),
    border: "".concat(BORDER_WIDTH_OUTER, "px solid ").concat(theme.selectors.color(BORDER_COLOR)),
    listStyle: 'none',
    padding: 0,
    margin: 0
  }, stripedProps);
});
CardList.displayName = 'CardList';

var CardLayoutBase = function CardLayoutBase(_ref2) {
  var data = _ref2.data,
      _ref2$getRowAttribute = _ref2.getRowAttributes,
      getRowAttributes = _ref2$getRowAttribute === void 0 ? defaultProps.getRowAttributes : _ref2$getRowAttribute,
      ariaLabelledby = _ref2['aria-labelledby'],
      shouldAutoCollapseOnExpand = _ref2.shouldAutoCollapseOnExpand,
      renderCardForRow = _ref2.renderCardForRow,
      spacing = _ref2.spacing,
      isStriped = _ref2.isStriped,
      forwardedProps = _objectWithoutProperties(_ref2, _excluded);

  var _useState = useState(mapIndexesToBooleans(data)),
      _useState2 = _slicedToArray(_useState, 2),
      expandedRows = _useState2[0],
      setExpandedRows = _useState2[1];

  var toggleExpanded = function toggleExpanded(index) {
    setExpandedRows(_objectSpread(_objectSpread({}, shouldAutoCollapseOnExpand ? setAllValuesToFalse(expandedRows) : expandedRows), {}, _defineProperty({}, index, !expandedRows[index])));
  };

  return ___EmotionJSX(CardList, _extends({}, pickDataProps(forwardedProps), {
    "aria-labelledby": ariaLabelledby,
    isStriped: isStriped,
    role: "list"
  }), data.map(function (dataItem, index) {
    return ___EmotionJSX(CardItem, {
      key: index,
      getRowAttributes: getRowAttributes,
      data: dataItem,
      index: index,
      toggleExpanded: toggleExpanded,
      renderCardForRow: renderCardForRow,
      spacing: spacing,
      isExpanded: expandedRows[index]
    });
  }));
};

var CardLayout = withTestAttributes({})(CardLayoutBase);
CardLayout.displayName = 'CardLayout';
export default CardLayout;